import React from "react"
import {StateProvider} from "./src/components/State";

export const wrapRootElement = ({ element }) => (
    <StateProvider>{element}</StateProvider>
);
